import ProfileHome from '@/screens/ProfileHome';

export default function PrivateProfileIndexRoute() {
  return <ProfileHome />;
}
